import { Outlet } from 'react-router-dom'
import { ResponsiveLayout } from '../../layouts/ResponsiveLayout'
import { Footer } from '../../components/Footer'
import { HeaderOrganization } from '../marketplace/components/HeaderOrganization'

export const GeneralLayout = () => (
    <ResponsiveLayout header={null} content={<Outlet />} aside={null} footer={<Footer />} />
)

export const HelloCenterLayout = () => (
    <ResponsiveLayout
        header={<HeaderOrganization />}
        content={<Outlet />}
        aside={null}
        footer={<Footer />}
    />
)

